var map = {
	"./heart-fill.svg": "587a",
	"./heart.svg": "7d16",
	"./icona-fangxiangzhishiyou.svg": "d935",
	"./icona-fangxiangzhishiyoujiantouyou.svg": "ab1c",
	"./icona-fangxiangzhishiyoushuangjiantouyou.svg": "91a6",
	"./pause.svg": "644b",
	"./play.svg": "dab1",
	"./star-fill.svg": "c0e7",
	"./star.svg": "cc90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";